module.exports = __webpack_public_path__ + "img/chest_male_posterior.6ac65b76.png";